import { getWalletConfig } from '../helpers/index.js';
import { buildSDPInitObject } from './buildSDPInitObject.js';

const openSDPWithRoute = async (route, refreshDsAfterSdpClose) => {
    if (window.accelerate) {
        const walletData = await getWalletConfig();
        const initObj = buildSDPInitObject(walletData, route, refreshDsAfterSdpClose);
        window.accelerate?.openShopperPlatform(initObj);
    } else {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('autoOpen', 'true');
        currentUrl.searchParams.set('dsLoad', 'true');
        currentUrl.searchParams.set('route', route);
        currentUrl.hash = '#mmd-widget';
        window.location.href = currentUrl.toString();
    }
}

export default openSDPWithRoute;